export enum ChecklistViewerStatus {
    Active,
    NotApplicable,
    AvailableLater,
    Ended,
    ScheduleNotSharedToBusinessUnit,
    ScheduleNotShared,
    NotScheduled,
    NotOperational,
    OperationalNotStarted,
    Unknown,
    OnDemandReadyToStart,
}
